import * as yup from 'yup';

export const schemaPaymentMethodCreate = yup.object().shape({
  description: yup.string().required('Descrição obrigatória'),
});

export const schemaPaymentMethodEdit = yup.object().shape({
  description: yup.string().required('Descrição obrigatória'),
  status: yup.boolean().required('Status obrigatório'),
});
